"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var environment_1 = require("@shared/types/environment");
var common_1 = require("@services/dynamic-translation/common");
var angular = __importStar(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
var RelationshipMenuService = /** @class */ (function () {
    function RelationshipMenuService(
    // @ts-ignore
    $http, 
    // @ts-ignore
    $filter, 
    // @ts-ignore
    $routeParams, 
    // @ts-ignore
    API_ROUTES, 
    // @ts-ignore
    env) {
        this.$http = $http;
        this.$filter = $filter;
        this.$routeParams = $routeParams;
        this.API_ROUTES = API_ROUTES;
        this.env = env;
        this.DEFAULT_RELATIONSHIP_MAP = {
            'ThreeSixty.DirectReport': 'PR.RELATIONSHIPS.DIRECT_REPORT',
            'ThreeSixty.Manager': 'PR.RELATIONSHIPS.MANAGER',
            'ThreeSixty.Peer': 'PR.RELATIONSHIPS.PEER',
            'ThreeSixty.Self': 'PR.RELATIONSHIPS.SELF',
            'ThreeSixty.#anyone#': 'PR.RELATIONSHIPS.ANYONE'
        };
        this.translate = this.$filter('translate');
    }
    RelationshipMenuService.prototype.getFormattedRelationships = function () {
        var _this = this;
        return this.getMenuPrepData()
            .then(function (data) {
            return lodash_1.default.map(data, function (datum) {
                // datum has relationshipId, translation, translationId
                var relationshipId = datum.relationshipId;
                var relationshipName = datum.translation
                    // @ts-ignore
                    || _this.translate(_this.DEFAULT_RELATIONSHIP_MAP[datum.translationId])
                    || relationshipId;
                return {
                    label: relationshipName,
                    value: relationshipId
                };
            });
        });
    };
    /**
     * Send aggregate request to get preparation data for 360 relationship dropdown menu
     */
    RelationshipMenuService.prototype.getMenuPrepData = function () {
        var threeSixtyId = this.$routeParams.projectId || this.env.get(environment_1.ENV_VARS.ACTIVE_PROJECT_ID);
        var language = common_1.getUserLanguage(this.env.get(environment_1.ENV_VARS.USER));
        var url = this.API_ROUTES.THREE_SIXTY_RELATIONSHIPS + "/threeSixty/" + threeSixtyId + "/translations";
        return this.$http.get(url, common_1.getLanguageHeaders(language))
            // @ts-ignore
            .then(function (response) {
            return response.data;
        });
    };
    RelationshipMenuService.$inject = [
        '$http',
        '$filter',
        '$routeParams',
        'pr.API_ROUTES',
        'rsEnvironment'
    ];
    return RelationshipMenuService;
}());
(function (angularModule) {
    angularModule.service('prRelationshipMenuService', RelationshipMenuService);
})(angular.module('qualtrics.pr'));
